/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited
// @ts-nocheck


import { DEFAULT_SIZE, type IconProps } from '../../npmlib-icons/src/types';


export const QrCode = ({ color = 'currentColor', size = DEFAULT_SIZE, ...props }: IconProps) => {
        return (
                <svg
                    width={size}
                    height={size}
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    {...props}>
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M9 4.5H5C4.72386 4.5 4.5 4.72386 4.5 5V9C4.5 9.27614 4.72386 9.5 5 9.5H9C9.27614 9.5 9.5 9.27614 9.5 9V5C9.5 4.72386 9.27614 4.5 9 4.5ZM5 3C3.89543 3 3 3.89543 3 5V9C3 10.1046 3.89543 11 5 11H9C10.1046 11 11 10.1046 11 9V5C11 3.89543 10.1046 3 9 3H5ZM19 4.5H15C14.7239 4.5 14.5 4.72386 14.5 5V9C14.5 9.27614 14.7239 9.5 15 9.5H19C19.2761 9.5 19.5 9.27614 19.5 9V5C19.5 4.72386 19.2761 4.5 19 4.5ZM15 3C13.8954 3 13 3.89543 13 5V9C13 10.1046 13.8954 11 15 11H19C20.1046 11 21 10.1046 21 9V5C21 3.89543 20.1046 3 19 3H15ZM5 14.5H9C9.27614 14.5 9.5 14.7239 9.5 15V19C9.5 19.2761 9.27614 19.5 9 19.5H5C4.72386 19.5 4.5 19.2761 4.5 19V15C4.5 14.7239 4.72386 14.5 5 14.5ZM3 15C3 13.8954 3.89543 13 5 13H9C10.1046 13 11 13.8954 11 15V19C11 20.1046 10.1046 21 9 21H5C3.89543 21 3 20.1046 3 19V15ZM13.0503 13.05H15.7003V15.7H18.3502V18.35H15.7002V15.7H13.0503V13.05ZM21.0006 13.05H18.3506V15.7H21.0006V13.05ZM21.0006 18.3501H18.3506V21.0001H21.0006V18.3501ZM13.0503 18.3501H15.7003V21.0001H13.0503V18.3501Z"
                        fill={color}
                    />
                </svg>
        );
    };
